import React, { useEffect, useRef } from "react";
import Content from "./Pages/Layout/Content";
import Login from "./Pages/Main/Login/Login";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function App() {
  const userId = localStorage.getItem("userId");

useEffect(() => {
  const script = document.createElement("script");
  script.src = `${process.env.PUBLIC_URL}/assets/js/scripts.js`;
  script.async = true;

  const timer = setTimeout(() => {
    document.body.appendChild(script);
  }, 100);

  return () => {
    clearTimeout(timer);
    if (document.body.contains(script)) {
      document.body.removeChild(script);
    }
  };
}, []);

  return (
    <>
      {userId === undefined ||
        !userId ||
        userId === null ||
        userId === "" ||
        userId === 0 ||
        userId === "undefined" ? (
        <Login />
      ) : (
        <Content />
      )}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        bodyClassName="toastBody"
        theme="colored"
      />
    </>
  );
}

export default App;
